export const loginAPI = (email: string, password: string) => {
    const user = {email: "user@conduent.com", role: "customer"};

    localStorage.setItem('user', JSON.stringify(user));

    return {
        user,
        message: "Everything is okay"
    }
}

export const logoutAPI = () => {
    localStorage.removeItem('user');

    return {
        message: "Everything is okay"
    }
}

export const checkLoginAPI = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') ?? '');
        return user;
    }
    catch(e) {
        return null;
    }
}